module.exports = __webpack_public_path__ + "img/ico_kb_type5_05.3c161953.png";